
export type IEnquiry = {
    statusDescription: string,
    statusId: number,
    customerName: string,
    enquiryNo: string,
    enquiryDate: number,
    productDescription: string,
    subProductDescription: string,
    temperature: string,
    id: number,
    customerAccount: string,
    productId: number
    subProductId: number
    temperatureId: number,
    originCountryId: number,
    originCountryName: string,
    destinationCountryId: number,
    destinationCountryName: string
}

export type IEnquiryCustomer = {
    isAccount: boolean,
    customerName?: string,
    customerId?: number,
    accountNumber?: string,
    address: string,
    contactPerson: string,
    email: string,
    countryId: number,
    mobile: number,
    cityId: number,
    clientSubId: number,
    createdBy?: number
}

export type ICargoDetails = {
    count: number,
    hsCode: string,
    imoNumber: string,
    packageTypeId: number,
    commodityTypeId: number,
    grossWeight: number,
    chargeableWeight: number,
    length: number,
    width: number,
    height: number,
    remarks: string,
    volume: number,
    enquiryOriginCityId: number,
    enquiryDestinationCityId: number
}

export type IManifestIRS = {
    waybillNo: string,
    pickedUpDate: number,
    deliveryDate: number,
    customerAccount: string,
    customerName: string,
    originCity: string,
    destinationCity: string,
    pieceCount: number,
    weight: number,
    bookedProduct: string,
    bookedSubProduct: string,
    pickedProduct: string,
    pickedSubProduct: string,
    basicMinCharge: number,
    basicAddWtCharge: number,
    bookedWeight: number,
    pickedUpWeight: number,
    additionalCharge: number,
    originOdaCharge: number,
    destOdaCharge: number,
    podCharges: number,
    labourCharges: number,
    forkliftAmount: number,
    codAmount: number,
    invoicedByManifester: number,
    fsc: number,
    salesperson: string,
    salespersonEmpId: number,
    manualFreightCharge: number,
    grossCharge: number,
    billType: string,
    industry: string,
    clearenceCharge: number,
    demurrageCharge: number,
    mainAccount: string,
    oracleSentStatus: string,
    originClearenceCharge: number,
    originHandling: number,
    originBayan: number,
    destinationClearenceCharge: number,
    destinationHandling: number,
    destinationBayan: number,
    transitCustomsDeclarationCharge: number,
    inspectionCharges: number,
    labTest: number,
    loadingOffloadingCharges: number,
    gatePassCharges: number,
    sealCharge: number,
    penalty: number,
    internationalFreightCharge: number,
    serviceCharge: number,
    totalAmount: number,
    vatAmount: number
};

export type IQuotationHeads = {
    id: number,
    head: number,
    uiBindName: number,
    isVatEnabled?: boolean | null
}
export type IQuotationPriceDetailList = {
    id?: number
    quotationHeadId?: number
    quotationHeadDescription?: string
    name?: string
    cost?: number
    selling?: number
    vatPercentage?: number
    vatAmount?: number
    currencyId?: number
    currencyCode?: string
    conversionRate?: number
    totalAmount?: number
    manifestQuotationExtraCharges?: number
    manifestQuotationVATExtraCharges?: number
    remarks?: string
    isVatEnabled?: boolean,
    vatId?: number
}
export type IQuotationDetails = {
    id?: number
    productId?: number
    quotationNumber?: string
    enquiryId?: number
    enquiryNumber?: string
    quotationValidDate?: number
    currencyId?: number
    currencyCode?: string
    quotationPriceDetailList?: Array<IQuotationPriceDetailList>
    totalCost?: number
    totalSelling?: number
    totalGrossAmount?: number
    enquiryOriginCityId?: number
    enquiryOriginCityCode?: string
    enquiryDestinationCityId?: number
    enquiryDestinationCityCode?: string
    accountNumber?: string
    customerName?: string
    clientSubId?: number
}
export type IEnquiryInitialState = {
    crmRequestData: [],
    crmEnquiryStatusList: [],
    updateCRMRequestStatusResponse: undefined,
    crmProductData: [],
    updateCRMProductResponse: undefined,
    crmCurrencyList: [],
    uploadedCRMEnquiryFile: {},
    uploadedCRMEnquiryFileById: undefined,
    enquiryResponse?: number,
    createEnquiryResponse?: number,
    updateCustomerResponse?: number,
    quotationRejectionsResponse?: number,
    quotationResponse?: number,
    enquiries: IEnquiry[],
    originCityPorts: IPort[],
    destinationCityPorts: IPort[],
    commodities: ICommodity[],
    packages: IPackage[],
    customers: INewCustomer[],
    quotations: IQuotation[]
    manifests: IManifestIRS[],
    quotationHeads: IQuotationHeads[],
    quotationRejections: IQuotationReject[],
    enquiryDetails: any,
    quotationDetails: IQuotationDetails
}

export type ICreateEnquiryForm = ICreateEnquiry & IEnquiryCustomer & ICargoDetails
export type ICreateEnquiry = {
    enquiryCustomer: IEnquiryCustomer,
    name?: string,
    accountId?: number,
    originCityId: number,
    destCityId: number,
    originPortId: number,
    destinationPortId: number,
    cargoDetails: ICargoDetails,
    productId: number,
    subProductId: number,
    temperatureId: number
}
export type IEditEnquiry = {
    id: number,
    name?: string,
    accountId?: number,
    originCityId: number,
    destCityId: number,
    originPortId: number,
    destinationPortId: number,
    cargoDetails: ICargoDetails,
}

export type IPort = {
    cityId: number,
    portName: string,
    shipmentModeId: number
}

export type ICommodity = {
    id: number,
    commodityTypeName: string,
    statusId: number
}
export type IPackage = {
    id: number,
    packageTypeName: string,
    statusId: number
}

export type ICustomer = {
    id: number | null,
    isAccount: boolean,
    customerId: number | null,
    customerName: string,
    address: string,
    contactPerson: string,
    mobile?: string,
    email: string,
    countryId: number,
    salesPersonId: number,
    cityId: number,
    createdBy: number | null,
    modifiedBy: number | null
}

export type INewCustomer = {
    id: number,
    isAccount: boolean,
    customerName: string,
    address: string,
    contactPerson: string,
    email: string,
    cityId: number,
}

export type IQuotationPriceDetail = {
    quotationHeadId: number,
    name: string,
    cost: number,
    selling: number,
    vatPercentage: number,
    vatAmount: number,
    currencyId: number,
    conversionRate: number,
    totalAmount: number,
    manifestQuotationVATExtraCharges?: number,
    isVatEnabled: boolean,
    manifestQuotationExtraCharges?: number
    vatId?: number
}
export type ICreateQuotation = {
    enquiryId?: number,
    quotationDate?: number,
    destinationCityId?: number,
    originCityId?: number,
    quotationValidDate?: number,
    currencyId?: number,
    productId?: number,
    totalCost?: number,
    totalSelling?: number,
    totalConvRate: number,
    totalGrossAmount: number,
    quotationPriceDetailList: IQuotationPriceDetail[]
}

export type IUpdateQuotation = ICreateQuotation & {
    id: number
}

export type IManifestQuote = {
    manifestId?: number,
    enquiryQuotationId?: number,
    enquiryId?: number,
    quotationNumber?: string
}

export interface IQuotation extends ICreateQuotation {
    id?: number,
    quotationNumber?: string,
    enquiryNumber?: string,
    currencyCode?: string,
    productDescription?: string,
    enquiryOriginCityId?: number,
    enquiryOriginCityCode?: string,
    enquiryDestinationCityId?: number,
    enquiryDestinationCityCode?: string
    accountNumber?: string,
    customerName?: string,
    clientSubId?: number
    quotationActionId?: number,
    quotationAction?: string,
    manifestQuote?: IManifestQuote
}


export type IPrintQuotationRequest = {
    enquiryQuotationId: number
}
export type IUpdateAccount = {
    quotationId: number,
    clientSubId: number,
    accountNumber: string,
    customerId: number
}


export type IRejectQuotation = {
    quotationId?: number,
    rejectionReasonId: number,
    remarks?: string
}
export interface IQuotationReject {
    id: number;
    description: string;
}
export const QUOTATION_LABEL = {
    INTERNATIONAL_FREIGHT_CHARGE: 'Freight Charge',
    ORIGIN_CLEARANCE_CHARGE: 'Origin Clearance Charge',
    ORIGIN_HANDLING: 'Origin Handling',
    ORIGIN_BAYAN: 'Origin Bayan',
    DESTINATION_CLEARANCE_CHARGE: "Destination Clearance Charge",
    DESTINATION_HANDLING: "Destination Handling",
    DESTINATION_BAYAN: "Destination Bayan",
    DETENTION_CHARGE: "Detention Charge",
    TRANSIT_CUSTOMS_DECLARATION_CHARGE: 'Transit Customs Declaration Charge',
    INSPECTION_CHARGE: 'Inspection Charge',
    LAB_TEST: 'Lab Test',
    LOADING_OFFLOADING_CHARGES: 'Loading/OffLoading Charges',
    GATE_PASS_CHARGES: 'Gate Pass Charges',
    SEAL_CHARGE: 'Seal Charge',
    PENALTY: 'Penalty',
    DOCUMENTATION_CHARGES: 'Documentation Charges',
    LOCAL_PICKUP: 'Local Pickup',
    LOCAL_DELIVERY: 'Local Delivery',
    PICK_UP_STORAGE: 'Pickup Storage',
    DELIVERY_STORAGE: 'Delivery Storage',
    JAFZA_CLEARANCE: 'Jafza Clearance',
    TOLL_CHARGES: 'Toll Charges',
    BORDER_APPOINTMENT_CHARGES: 'Border Appointment Charges',
    ADDITIONAL_DELIVERY_CHARGES: "Additional Delivery Charges",
    CAUSEWAY_BRIDGE_CHARGES: 'Causeway Bridge Charges',
    DATA_LOGGER_CHARGES: 'Data Logger Charges',
    MISCELLANEOUS: 'Miscellaneous',
    CUSTOMS_DUTY_CHARGES: 'Customs Duty Charges',
} as const

export const QUOTATION_KEY = {
    INTERNATIONAL_FREIGHT_CHARGE: 'internationalFreightCharge',
    ORIGIN_CLEARANCE_CHARGE: "originClearenceCharge",
    ORIGIN_HANDLING: "originHandling",
    ORIGIN_BAYAN: "originBayan",
    DESTINATION_CLEARANCE_CHARGE: "destinationClearenceCharge",
    DESTINATION_HANDLING: "destinationHandling",
    DESTINATION_BAYAN: "destinationBayan",
    DETENTION_CHARGE: "detentionCharge",
    TRANSIT_CUSTOMS_DECLARATION_CHARGE: "transitCustomsDeclarationCharge",
    INSPECTION_CHARGE: "inspectionCharges",
    LAB_TEST: "labTest",
    LOADING_OFFLOADING_CHARGES: "loadingOffloadingCharges",
    GATE_PASS_CHARGES: "gatePassCharges",
    SEAL_CHARGE: "sealCharge",
    PENALTY: "penalty",
    DOCUMENTATION_CHARGES: "documentationCharges",
    LOCAL_PICKUP: 'localPickup',
    LOCAL_DELIVERY: 'localDelivery',
    PICK_UP_STORAGE: 'pickupStorage',
    DELIVERY_STORAGE: 'deliveryStorage',
    JAFZA_CLEARANCE: 'jafzaClearance',
    TOLL_CHARGES: 'tollCharges',
    BORDER_APPOINTMENT_CHARGES: 'borderAppointmentCharges',
    ADDITIONAL_DELIVERY_CHARGES: "additionalDeliveryCharges",
    CAUSEWAY_BRIDGE_CHARGES: 'causewayBridgeCharges',
    MISCELLANEOUS: 'miscellaneous',
    DATA_LOGGER_CHARGES: 'dataLoggerCharges',
    CUSTOMS_DUTY: 'customsDuty',
} as const